/** AppLayout 반응형 브레이크포인트 (H4) */
export const MOBILE_BREAKPOINT_PX = 768;

/** Site Studio · RESPONSIVE_STRATEGY lg — 3-column desktop grid */
export const DESKTOP_BREAKPOINT_PX = 1024;
